// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"270efac2","239":"1831c22a","667":"5aef3734"}[chunkId] + ".chunk.js";
};